import { render, staticRenderFns } from "./Page_RejoinRequest.vue?vue&type=template&id=639d4147&scoped=true&"
import script from "./Page_RejoinRequest.vue?vue&type=script&lang=js&"
export * from "./Page_RejoinRequest.vue?vue&type=script&lang=js&"
import style0 from "./Page_RejoinRequest.vue?vue&type=style&index=0&id=639d4147&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639d4147",
  null
  
)

export default component.exports